import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HomeCTA() {
  const { t } = useTranslation();

  return (
    <section className="bg-[#0A1628] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-16 py-16 flex flex-col md:flex-row items-center justify-between gap-8">
        <div>
          <h3 className="text-3xl lg:text-4xl font-extrabold leading-tight mb-2 text-white">
            Ready to <span className="text-[#00C2C2]">Grow</span> in East Africa?
          </h3>
          <p className="text-white/50 text-sm">
            {t("ctaDesc")}
          </p>
        </div>
        <div className="flex flex-wrap gap-4 flex-shrink-0">
          <Link
            to="/contact"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-7 py-4 rounded-full bg-[#00C2C2] text-white font-semibold text-sm hover:bg-[#00AAAA] transition-all duration-300 hover:-translate-y-0.5"
          >
            {t("ctaBtn1")} <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/services"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-7 py-4 rounded-full border border-white/20 text-white font-semibold text-sm hover:bg-white/10 transition-all duration-300 hover:-translate-y-0.5"
          >
            {t("ctaBtn2")}
          </Link>
        </div>
      </div>
    </section>
  );
}